// Single list of checkout payment methods, used by the Web and Mobile
// overviews and the WooCommerce section, so every page names them the same way.
export const PAYMENT_METHODS = [
    {
        name: 'Dynamic virtual account',
        description: 'A one-time account number created for this payment. The customer transfers the exact amount into it.',
    },
    {
        name: 'WayaBank transfer',
        description: 'The customer pays money directly from their wayabank account',
    },
    {
        name: 'Card',
        description: 'Visa, Mastercard and Verve debit and credit cards.',
    },
    {
        name: 'USSD',
        description: "The customer dials their bank's USSD code. No internet or smartphone needed.",
    },
    {
        name: 'PayAttitude',
        description: "The customer pays with the phone number linked to their bank account.",
    },
];

export const PAYMENT_METHOD_NAMES = PAYMENT_METHODS.map((m) => m.name);